export default __webpack_public_path__ + "static/media/daveHeadshot.cbfe84db.png";